'use client';

export { useAddToCart } from '@eliadmin/core/src/hooks/cart/use-add-to-cart';
